import 'rxjs/add/operator/do';
/**
 * Interceptor that adds the authentication header to request
 */
var AuthInterceptor = (function () {
    function AuthInterceptor() {
    }
    /**
     * Intercepts the request and adds the authentication header
     * @param {HttpRequest<any>} req Request
     * @param {HttpHandler}      next HttpHandler
     * @returns {Observable<HttpEvent<any>>} Observable<HttpEvent<any>>
     */
    AuthInterceptor.prototype.intercept = function (req, next) {
        var currentAuthHeader = req.headers.get('Authorization');
        // If Authorization header is empty, remove authorization header and pass on the original request
        if (currentAuthHeader === '') {
            req.headers.delete('Authorization');
            return next.handle(req);
        }
        // If Authorization header is already set, pass on the original request
        if (currentAuthHeader !== null) {
            return next.handle(req);
        }
        // Get the auth header from the service.
        var authHeader = localStorage.getItem('UserToken') || '';
        // Clone the request to add the new header.
        var authReq = req.clone({ setHeaders: { Authorization: authHeader } });
        // Pass on the cloned request instead of the original request.
        return next.handle(authReq);
    };
    return AuthInterceptor;
}());
export { AuthInterceptor };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/shared/services/auth.interceptor.ts.pre-build-optimizer.js